export default __webpack_public_path__ + "static/media/vu.f228f473.svg";